import { useState } from "react";

import useTrucks from "../../data/useTrucks";
import { ITruck } from "../../models/Truck";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import PaginatedJobSheetTable from "../schedule/PaginatedJobSheetTable";
import TruckOrderModal from "./TruckOrderModal";

export default function PrintJobSheet({ selectedDay, week, year }: { selectedDay: string | undefined, week: number, year: number }) {
  const { trucks } = useTrucks();
  const [modalOpen, setModalOpen] = useState(false);
  const [orderedTrucks, setOrderedTrucks] = useState<ITruck[]>([]);

  function printSection() {
    var content = document.getElementById("print-section");
    var iframe = document?.getElementById("frame") as HTMLIFrameElement;
    var pri = iframe.contentWindow;
    pri?.document.open();
    pri?.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
        * {
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
        table, th, td {
          padding: 5px;
          border: 1px solid black;
          border-collapse: collapse;
          font-family: 'Poppins', sans-serif;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
        table {
          width: 100%;
        }
        /* Each truck prints on its own page so sheets can be handed out per driver. */
        .truck-section {
          break-after: page;
          page-break-after: always;
        }
        .truck-section:last-child {
          break-after: auto;
          page-break-after: auto;
        }
        /* Repeat the truck name + column headers if a truck spills onto extra pages. */
        thead {
          display: table-header-group;
        }
        .truck, th {
          background-color: #dbeafe;
        }
        .awaiting {
          // background-color: #FF0000;
        }
        .export {
          background-color: #ffff00;
        }
        .sales {
          background-color: #86dc3d;
        }
        .scrap {
          background-color: #90bbe8;
        }
        .cancelled {
          background-color: #e97451;
        }
        </style>
      </head>
      <body>
        ${content!.innerHTML}
      </body>
    </html>
  `);
    pri?.document.close();
    pri?.focus();
    pri?.print();
  }

  function handleConfirm(ordered: ITruck[]) {
    setOrderedTrucks(ordered);
    // Allow React to re-render the hidden table with the new order before printing
    setTimeout(() => printSection(), 0);
  }

  function handleOpenModal() {
    const activeTrucks = trucks.data?.data ?? [];
    setOrderedTrucks(activeTrucks);
    setModalOpen(true);
  }

  return (
    <>
      <ButtonInput
        label="Print Job Sheet"
        isSubmit={false}
        disabled={!selectedDay}
        onClick={handleOpenModal}
        classes={!selectedDay ? "bg-gray-400 hover:bg-gray-400" : undefined}
      />
      <TruckOrderModal
        open={modalOpen}
        setOpen={setModalOpen}
        trucks={trucks.data?.data ?? []}
        onConfirm={handleConfirm}
      />
      <div className="hidden" id="print-section">
        <PaginatedJobSheetTable selectedDay={selectedDay} week={week} year={year} orderedTrucks={orderedTrucks} />
      </div>
      <iframe id="frame" className="h-0 w-0 absolute"></iframe>
    </>
  )
}
